import { Formik } from "formik";
import React , {useState, useEffect }from "react";
import {Form, Modal, ListGroup, Table, Button, Col } from "react-bootstrap";


export function ProductModal({ visible, setModal, data, mark, selected}) {
    
    const [name, setName] = useState("");

    return (
        <>
            <Modal show={visible}>
                <Modal.Body className="cursor-default">
                    <Form className="form form-label-right">
                        <div className="form-group row">
                            <div className="col">
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Search Product</Form.Label>
                                    <Form.Control onChange={(event) => {
                                        let name = event.target.value.toUpperCase()
                                        setName(name)
                                    }} type="text" placeholder="Type product name" />
                                    <Form.Text className="text-muted">
                                        filter by product name
                                    </Form.Text>
                                </Form.Group>
                            </div>
                        </div>
                        <div>
                            <div className="col">
                                <ListGroup className="">
                                    {
                                        data.filter( item => {
                                            if(!name){
                                                return true
                                            }
                                            if (item.name.toUpperCase().includes(name)) {
                                                return true
                                            }
                                            return false
                                        }).map((e,i) => (
                                            <ListGroup.Item key={e.uid}  className="d-flex justify-content-between">
                                                {e.name}
                                                <input 
                                                    defaultChecked={selected?.includes(e.uid)}
                                                    onClick={({target}) => {
                                                        if (selected?.includes(e.uid)){
                                                            mark(e.uid, false, 1)
                                                            target.removeAttribute('checked');
                                                        } else {
                                                            mark(e.uid, true,1)
                                                            target.setAttribute('checked', true);
                                                        }}}
                                                    type="checkbox" label="Check me out" />
                                            </ListGroup.Item> 
                                        ))
                                    }
                                </ListGroup>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={() => {setModal(false,"product_visible" ); setName("")} }
                        className="btn btn-light btn-elevate"
                    >
                        Close
                    </button>
                    <> </>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export function ReportModal(props){
    const [selected, setSelected] = useState(props.selectedReports ?? props.client.reports ?? []);
    useEffect(() => {
      setSelected(props.selectedReports);
    }, [props.selectedReports]);

    useEffect(() => {
       setSelected(props.client.reports ?? [])
    }, [props.client.reports])

   

    const [ setFilter] = useState("");
   
    const _reports = props.reports.filter(rpt => (props.client.reports ?? []).includes(rpt.uid))

    function handleSelect(uid) {
        if (selected.includes(uid)) {
          const newSelected = selected.filter((e) => e !== uid);
          setSelected(newSelected);
        } else {
          setSelected([...selected, uid]);
        }
      }

      function selectAll(rows) {
        setSelected(rows);
      }

     
    return (
      <Formik
      enableReinitialize={true}
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={props.client}
      onSubmit={() => {
        const doc = {...props.client , reports: props.selectedReports};
          props.update(doc)
        
      }}
      >
       {
           ({handleSubmit}) => (
            <Modal show={props.show} onHide={props.handleClose} size="lg">
            <Modal.Header>
              <h2>{props.client.uid ? "Edit Reports" : "Manage Reports"}</h2>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-lg-4 ">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onChange={({ target }) => setFilter(target.value)}
                  />
                  <small className="form-text text-muted">
                    <b>Search</b> in all fields
                  </small>
                </div>
                <div className="col-lg-4 ">
                  {/* <Button >
                                Create Task
                            </Button> */}
                </div>
              </div>
              <Col
                xs={12}
                style={{ overflowY: "scroll", height: "100%", maxHeight: "40vh" }}
              >
                <Table hover size="md">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          className="checkbox-table"
                          checked={_reports.length === selected.length}
                          onChange={() => {}}
                          onClick={() =>
                            _reports.length === selected.length
                              ? selectAll([])
                              : selectAll(_reports.map((t) => t.uid))
                          }
                        />
                      </th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {_reports
                      .sort((a, b) => {
                        if (a.name < b.name) {
                          return -1;
                        }
                        if (a.name > b.name) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((report) => (
                        <tr
                          key={report.uid}
                          onClick={() => handleSelect(report.uid)}
                        >
                          <td>
                            <input
                              type="checkbox"
                              className="checkbox-table"
                              checked={selected.includes(report.uid)}
                              onChange={() => {}}
                              onClick={() => handleSelect(report.uid)}
                            />
                          </td>
                          <td>{report.name}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={props.handleClose}>
                Cancel
              </Button>
              <Button
                variant="success"
                onClick={() => {
                  props.setSelectedReports(selected);
                 handleSubmit();
                }}
              >
                 Save
              </Button>
            </Modal.Footer>
          </Modal>
           )
       }
      </Formik>
    );
}

export function ClienDeleteModal(props) {
    return (
      <>
        <Modal
          show={props.delete}
          onHide={props.hideDelete}
          size="lg"
          dialogClassName="p-5"
        >
          <Modal.Header>
            <h1>Delete Campaign</h1>
          </Modal.Header>
          <Modal.Body>
            Are you sure to permanently delete this <b>Campaign</b>?
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              onClick={props.hideDelete}
              className="btn btn-light btn-elevate"
            >
              Cancel
            </button>
            <> </>
            <button
              type="submit"
              onClick={() => props.deleteClient(props.client.uid)}
              className="btn btn-danger btn-elevate"
            >
              Delete

            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }